export const STRIPE_TEST_KEY = `${process.env.REACT_APP_STRIPE_TEST_KEY}`;
export const PerPaginationPageData = 25;

export const ROLE = {
  USER: "user",
  ADMIN: "admin",
};
